export default [
    {
        name: 'check-in',
        path: '/check-in/:id',
        component: ( ) => import('@/views/check_in_form/CheckInFormView.vue')
    }
]